module.exports = __webpack_public_path__ + "static/media/toilet_paper_getty_tablet.e59b1647.jpg";